import { DenyItemRequestState } from './denyItemRequest.types'

const initialState: DenyItemRequestState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
